import React, {useEffect} from "react";
import * as ReactDOMClient from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from "./src/components/App";
import { ToastContainer, toast } from 'react-custom-alert';
import 'react-custom-alert/dist/index.css'; // import css file from root.

require('./bootstrap');

/*
you should add a null-check, but Typescript also has a non-null assertion that you can use when you are sure that the value is never null by adding the ! operator to the end of your statement:
* */
const container = document.getElementById('app')!;
const root = ReactDOMClient.createRoot(container);

root.render(
    <>
        <BrowserRouter>
            <App/>
        </BrowserRouter>
        <ToastContainer floatingTime={2750} />
    </>
);
